import { yardManagementServiceStores } from "@intrasync/yard-management";
import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Yard Management Module Service Stores
 *
 * Sourced directly from `@intrasync/yard-management` (`yardManagementServiceStores`)
 * so they stay in sync whenever the package is upgraded — see the package's
 * `dist/serviceStores.js` for the authoritative list (grid-layouts,
 * grid-layout-blocks, asset-placements, assets, asset-types, zones, yards).
 *
 * ServiceStore registration is first-wins/idempotent (see
 * StoreRegistry.registerServiceStore), so any name another module already
 * registers with richer config is filtered out here to avoid shadowing it.
 * As of wiring, none of the yard-management store names collide with existing
 * registrations, so the set below is empty — populate it if a future collision
 * arises.
 */
const STORES_OWNED_BY_OTHER_MODULES = new Set<string>([]);

export const yardManagementStores: ServiceStoreConfig[] = (
  yardManagementServiceStores as unknown as ServiceStoreConfig[]
).filter((store) => !STORES_OWNED_BY_OTHER_MODULES.has(store.name));
